jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.image').length ) {
        let $ = jQuery;

        var $slickElement = $('.image .image-holder');
        var $status = $('.image .pagingInfo');

        $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '/' + slick.slideCount);
        });

        $slickElement.slick({
            arrows: true,
            dots: false,
            fade: true,
            rows: 0
        });
    }
});